 <!-- container -->
<p-blockUI [blocked]="blockedDocument">
 <div class="fixed inset-0 flex flex-col items-center justify-center bg-gray-900/50 z-50">
        <p-progressSpinner></p-progressSpinner>
        <span class="text-white text-lg mt-4">Loading organizations...</span>
 </div>
</p-blockUI>
<p-toast />
<div>
    <div class="flex flex-col mb-6">
        <h3 class="text-2xl font-bold text-surface-900 dark:text-surface-0 mb-1">Organizations</h3>
        <span class="text-surface-500 text-sm">Manage organizations and their user associations</span>
    </div>

    <div class="mb-6">
    <p-toolbar [style]="{ width: '70w' }">
        <ng-template #start #form>
            <p-iconfield iconPosition="left">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" [(ngModel)]="name" pInputText placeholder="Search by name" />

            </p-iconfield>
        </ng-template>
        <ng-template #end>

            <p-button (onClick)="showDialog()">New Organization</p-button> 
        </ng-template>
    </p-toolbar>
</div>


    @if (organizations && organizations.length > 0) {
    <p-table [value]="filteredItems" [tableStyle]="{ 'min-width': '50rem' }"
             [paginator]="true" 
             [rows]="10"
             [rowsPerPageOptions]="[5, 10, 20, 50]">
             
        <ng-template #header>
            <tr>
                <th pSortableColumn="name"> Name<p-sortIcon field="name" /></th>
                <th>Actions</th>                
            </tr>
        </ng-template>
        <ng-template #body let-organization>
            <tr (click)="showEdit(organization)">
                <td>{{ organization.name }}</td>
                <td><i class="pi pi-pencil hover:cursor-pointer" (click)="showEdit(organization)" aria-label="Edit organization" role="button" tabindex="0" (keydown.enter)="showEdit(organization)" (keydown.space)="$event.preventDefault(); showEdit(organization)"></i>
                </td>
            </tr>
        </ng-template>
    </p-table>
    } @else {
        <div class="flex flex-col items-center justify-center py-12 text-center">
            <i class="pi pi-building text-4xl text-surface-400 mb-4"></i>
            <p class="text-lg text-surface-500 mb-4">No organizations found</p>
            <p-button label="New Organization" icon="pi pi-plus" (click)="showDialog()"></p-button>
        </div>
    }
    <app-new-organization (closeDialog)="closeDialog($event)" [visible]="visible" ></app-new-organization>
    <app-edit-organization (closeDialog)="closeEditDialog($event)" [visible]="editVisible" [organization]="editOrganization"></app-edit-organization>

</div>